import { memo, useCallback, useState } from 'react';
import { FormSpy } from 'react-final-form';
import cn from 'classnames';

import { Button } from 'UIPackage/MainModule/components/Button';
import { KnmAttachmentsSigning } from 'KnmPackage/MainModule/components/KnmAttachmentsSigning';
import { IKnmAttachment } from 'APIPackage/KnmModule/interfaces/IKnmAttachment';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';

import styles from './index.module.scss';

interface IDecisionReasonDocumentProps {
  watchOnly: boolean;
  name: string;
  attachment: IKnmAttachment[] | null | undefined;
  formRef?: IDecisionFormRef;
  title: React.ReactNode;
  errorFieldKey: string;
}

export const DecisionReasonDocument = memo(
  ({ watchOnly, name, attachment, formRef, title, errorFieldKey }: IDecisionReasonDocumentProps) => {
    const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);

    const openSignModal = useCallback(() => setIsVisibleSignModal(true), []);
    const closeSignModal = useCallback(() => setIsVisibleSignModal(false), []);

    return (
      <div className={styles.Document}>
        <div className="shared-group-label">
          {title}
          <span className="shared-no-wrap-text">
            <Button
              className={cn('shared-btn-add', styles.DocumentAddButton)}
              text="Добавить"
              variant="link"
              color="primary"
              type="button"
              id="fileAddButton"
              disabled={watchOnly || (!!attachment && attachment.length > 0)}
              onClick={openSignModal}
            />
          </span>
        </div>

        <KnmAttachmentsSigning
          acceptedFiles=".pdf,.png,.jpeg,.ktd,.rtf,.rar,.zip"
          isWatchOnly={watchOnly}
          name={name}
          isVisibleSignModal={isVisibleSignModal}
          closeSignModal={closeSignModal}
          formRef={formRef}
        />
        <FormSpy subscription={{ errors: true, touched: true }}>
          {props => {
            const fieldError = props.errors?.reasons?.[0]?.[errorFieldKey];
            const errorMessage: string | undefined = fieldError
              ? (Object.values(fieldError).reduce((prev: string, curr: string) => prev + curr, '') as string)
              : undefined;

            if (errorMessage) {
              return <p className="shared-input-error shared-row__small-margin">{errorMessage}</p>;
            }

            return null;
          }}
        </FormSpy>
      </div>
    );
  },
);
